import type { OrderResponse } from '@/queries/useCart';
import { useTranslation } from 'react-i18next';

interface ReceiptTotalsProps {
  order: OrderResponse['data'];
  eta?: number;
}

export function ReceiptTotals({ order, eta = 20 }: ReceiptTotalsProps) {
  const { i18n } = useTranslation('customer');
  const isRTL = i18n.language === 'ar';

  const subtotalEGP = (order.total / 100).toFixed(1);
  const taxEGP = '0.0'; // MVP: No tax
  const totalEGP = (order.total / 100).toFixed(1);

  return (
    <div className="space-y-2">
      {/* Subtotal */}
      <div className={`flex justify-between text-sm ${isRTL ? 'flex-row-reverse' : ''}`}>
        <span>{isRTL ? 'المجموع الفرعي' : 'Subtotal'}</span>
        <span className="font-semibold">{subtotalEGP} EGP</span>
      </div>

      {/* Tax (placeholder for future) */}
      <div className={`flex justify-between text-sm ${isRTL ? 'flex-row-reverse' : ''}`}>
        <span>{isRTL ? 'الضريبة' : 'Tax'}</span>
        <span className="font-semibold">{taxEGP} EGP</span>
      </div>

      {/* Divider */}
      <div className="border-t border-gray-400 my-2" />

      {/* Total */}
      <div className={`flex justify-between text-lg font-bold ${isRTL ? 'flex-row-reverse' : ''}`}>
        <span>{isRTL ? 'الإجمالي' : 'Total'}</span>
        <span>{totalEGP} EGP</span>
      </div>

      {/* ETA */}
      <div className="mt-4 pt-4 border-t border-dashed border-gray-400 text-center">
        <p className="text-sm font-semibold">
          {isRTL ? `جاهز في ${eta} دقيقة` : `Ready in ${eta} minutes`}
        </p>
      </div>

      {/* Thank You Message */}
      <div className="text-center mt-4 pt-4 border-t border-dashed border-gray-400">
        <p className="text-sm font-semibold">
          {isRTL ? 'شكراً لطلبك!' : 'Thank you for your order!'}
        </p>
        <p className="text-xs text-muted-foreground mt-1">
          {isRTL ? 'نتمنى لك وجبة شهية' : 'We hope you enjoy your meal'}
        </p>
      </div>
    </div>
  );
}








